import { render, staticRenderFns } from "./CvPreview.vue?vue&type=template&id=461afd47&"
import script from "./CvPreview.vue?vue&type=script&lang=js&"
export * from "./CvPreview.vue?vue&type=script&lang=js&"
import style0 from "../../statics/css/cvpreview.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports